// Home page counters.

export // Placeholder figures — edit these four values to match live operational data.
const STATS = [
  { v: 250000, suffix: "+", l: "Deliveries completed" },
  { v: 40, suffix: "", l: "Fleet vehicles" },
  { v: 100, suffix: "%", l: "UK & Ireland coverage" },
  { v: 120, suffix: "+", l: "Business clients" },
];

export default STATS;
